import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from '@helpers/helper';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { ExpedienteFilter } from '@models/expediente/expedienteFilter.model';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { JuzgadoParteService } from '@services/juzgadoParte/juzgado-parte.service';
import { JuzgadoParteDto } from '@models/juzgadoParte/juzgadoParteDto.model';
import { DialogFormJuzgadoComponent } from '../dialog-form-juzgado/dialog-form-juzgado.component';
import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BuscarExpedienteComponent } from '@views/busquedas/buscar-expediente/buscar-expediente.component';
import { ButtonAddComponent } from 'src/app/component/button-add/button-add.component';
import { ButtonCancelDialogComponent } from 'src/app/component/button-cancel-dialog/button-cancel-dialog.component';
import { ButtonCloseDialogComponent } from 'src/app/component/button-close-dialog/button-close-dialog.component';
import { ButtonCloseComponent } from 'src/app/component/button-close/button-close.component';
import { ButtonDeleteAndCancelComponent } from 'src/app/component/button-delete-and-cancel/button-delete-and-cancel.component';
import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';

@Component({
  selector: 'app-form-juzgado-view',
  templateUrl: './form-juzgado-view.component.html',
  styleUrls: ['./form-juzgado-view.component.css'],
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatDialogModule, ButtonCloseDialogComponent, A11yModule, CommonModule, MatExpansionModule, ButtonSaveComponent, ButtonDeleteAndCancelComponent, ButtonCloseComponent, MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule, MatInputModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, MatNativeDateModule, BuscarExpedienteComponent, MatTabsModule, ButtonCloseDialogComponent, ButtonCancelDialogComponent, ButtonAddComponent, MatCheckboxModule],
})
export class FormJuzgadoViewComponent {

  dataSourceExpediente = new MatTableDataSource<ExpedienteDto>();
  dataExpediente: boolean = false
  displayedColumnsExpediente!: string[];
  juzgadoDto!: JuzgadoDto;
  idJuzgado: any;
  juzgadoParteDto!: JuzgadoParteDto[];
  displayedColumnsJuzgadoParte!: string[];
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private juzgadoService: JuzgadoService,
    private snackBar: SnackBarService,
    private breakpointObserver: BreakpointObserver,
    private expedienteService: ExpedienteService,
    private juzgadoParteService: JuzgadoParteService

  ) {
    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumnsExpediente = result.matches ?
        ["caratula", "accion"] :
        ["caratula", "identificadorUnico", "estadoExpediente", "estadoExpedientePerito", "accion"];
    });

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumnsJuzgadoParte = result.matches ?
        ["caratula", "accion"] :
        ["caratula", "identificadorUnico", "estadoExpediente", "estadoExpedientePerito", "accion"];
    });

  }


  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  ngOnInit(): void {
    this.idJuzgado = this.activatedRoute.snapshot.params['id']
    this.getJuzgadoById(this.idJuzgado)
    this.getAllExpedienteByIdJuzgados(this.idJuzgado)
    this.getJuzgadoParteIdJuzgado(this.idJuzgado)
  }
  getJuzgadoById(id: number) {
    this.spinner.show("spJuzgado")
    this.juzgadoService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spJuzgado")
          this.juzgadoDto = data
        },
        error => {
          this.spinner.hide("spJuzgado")
          this.snackBar.showError(error, "Error");
        })
  }

  getJuzgadoParteIdJuzgado(id: number) {
    this.spinner.show("spJuzgadoParte")
    this.juzgadoParteService.getAllByIdJuzgado(id)
      .subscribe(
        data => {
          this.spinner.hide("spPersona")
          this.juzgadoParteDto = data
        },
        error => {
          this.spinner.hide("spPersona")
          this.snackBar.showError(error, "Error");
        })
  }

  openDialogDelete(obj: any) {
    obj.descripcion = obj.caratula
    obj.id = obj.id
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%",
      dialogConfig.autoFocus = false;
    dialogConfig.data = obj

    const dialogRef = this.dialog.open(DialogDeleteComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      //this.deleteRowData(result.data);
    });
  }

  copiarAlPortapapeles(texto: string) {
    Helper.copyToClipboard(texto)
  }


  getAllExpedienteByIdJuzgados(idJuzgado: number) {
    this.spinner.show('spExpediente')
    let expedienteFilter = new ExpedienteFilter
    expedienteFilter.idsJuzgados = [idJuzgado]
    this.expedienteService.getAllExpedientesByFilter(expedienteFilter)
      .subscribe(
        data => {
          this.spinner.hide('spExpediente')
          this.dataSourceExpediente.data = data.sort((a, b) => a.caratula.toString().localeCompare(b.caratula.toString())) as ExpedienteDto[]
          this.dataExpediente = this.dataSourceExpediente.data.length >= 1 ? true : false

        },
        error => {
          this.spinner.hide('spExpediente')
          this.snackBar.showError(error, "Error");
        })
  }

  openDialog(action: any, obj: any) {
    obj.action = action;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "50%"
    dialogConfig.autoFocus = false;
    dialogConfig.data = obj
    obj.descripcion = isFalsy(obj.expediente) ? null : obj.expediente.caratula

    const dialogRef = this.dialog.open(DialogFormJuzgadoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result: { data: any; }) => {
      switch (result.data.action) {
        case AccionesDialog.Ver:
          break;
        default:
          //this.getAllByIdLocalidad(this.localidadDto.id)
          break;
      }
    });
  }
}
